import { WebWrapper } from '../../components/WebWrapper'
import { DesktopHeader, HeaderDesktopProvider } from '../Home/partials/DesktopHeader'

import { ProfileUser } from './ProfileUser'

export default () => (
  <HeaderDesktopProvider>
    <DesktopHeader />
    <WebWrapper flex={1} flexShrink={0}>
      <ProfileUser />
    </WebWrapper>
  </HeaderDesktopProvider>
)
